import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vueScrollto from 'vue-scrollto';
import axios from 'axios';

// Create a new Vue app
const app = createApp(App);

// Set Axios as a global property
app.config.globalProperties.$axios = axios;

// Use plugins
app.use(vueScrollto);
app.use(router);
app.use(store);

// Global directive for click outside
app.directive('click-outside', {
  beforeMount(el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.component?.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be.`;
      if (compName) {
        warn += ` Found in component '${compName}'`;
      }
      console.warn(warn);
    }

    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e); // Call the provided function
      }
    };

    // Add Event Listeners
    document.addEventListener('click', handler);
    el.__vueClickOutside__ = handler;
  },
  unmounted(el) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  },
});

// Global filter for formatting numbers
app.config.globalProperties.$filters = {
  formatNumber(value) {
    return numeral(value).format('0,0'); // Displaying other groupings/separators is possible, look at the docs
  },
};


// Define the global currancy formating method
app.config.globalProperties.$formatNumber = (value) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'decimal', // Use 'decimal' for plain numbers without currency
    minimumFractionDigits: 0, // No decimal places
    maximumFractionDigits: 0, // No decimal places
  }).format(value);
};

// Mount the app
app.mount('#app');

// NEED TO BE ADRESSED TO WORK AFTER MIGRtring to VUE3

// Vue.filter("formatNumber", function (value) {
//   return numeral(value).format("0,0"); // displaying other groupings/separators is possible, look at the docs
// });